<template>
  <div style="width:100%;height:100%"  ref="myChart">

  </div>
</template>
<script >
import * as echarts from "echarts";
export default{
  name:'echarts',
  props:{
    option:{
      type:Object,

    }
  },
  methods:{
    setEchart(elementl,option){
      var myChart = echarts.init(elementl);

        myChart.setOption(option);
    },
    initChart(){ //调用绘制方法
      this.setEchart(this.$refs.myChart,this.option)
    }
  },
  mounted(){
  //页面重绘
  this.initChart()
    window.addEventListener('resize',()=>{
      this.initChart()
    })
  },
  watch:{
    option:{
      handler(){
        if(this.$refs.myChart){

          this.initChart()
        }
      },
      deep:true,
      immediate:true
    }
  }


}
</script>
